import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import ConfigurationsFeedbacksEvaluationsService from "../../../../services/api/configurations/ConfigurationsFeedbacksEvaluations.service";
import { useNotification } from "../../../notification.hook";
import { UpdateFeedbacksEvaluationsConfig } from "../../../../types/api/configurations.type";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { useEffect } from "react";

const MANAGE_CONFIG_FEEDBACKS_QUERY_KEY = "get-config-feedbacks-evaluations";

export const useManageFeedbacks = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError } = useQuery({
    queryKey: [MANAGE_CONFIG_FEEDBACKS_QUERY_KEY, configYear],
    queryFn: () => ConfigurationsFeedbacksEvaluationsService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching };
};

export const useUpdateManageFeedbacks = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["update-manage-feedbacks-evaluations"],
    mutationFn: (result: UpdateFeedbacksEvaluationsConfig) =>
      ConfigurationsFeedbacksEvaluationsService.update(result),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MANAGE_CONFIG_FEEDBACKS_QUERY_KEY],
      });
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
    },
    onError: (error) => {
      console.error(`errore updating feedbacks evaluations config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, isPending };
};
